namespace SP {
    export function insertAfter(newNode: HTMLElement, existingNode: HTMLElement) {
        existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
    }

    export function insertBefore(newNode: HTMLElement, existingNode: HTMLElement) {
        existingNode.parentNode.insertBefore(newNode, existingNode);
    }

}